import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { BsAwardFill  } from "react-icons/bs";
import { MdBuild, MdTimer, MdMenu, MdClose } from "react-icons/md";
import { FaTags, FaUser, FaBrain } from "react-icons/fa";
import { useMediaQuery } from 'react-responsive';

const Navbar = () => {
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <div>
      {/* Main Navbar */}
      <nav className="sticky top-0 z-50 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 shadow-2xl border-b border-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-28">
            {/* Logo */}
            <Link
              to="/"
              className="flex items-center space-x-3 group"
              onClick={closeMobileMenu}
            >
              <img 
                src="./img/logo.png" 
                alt="ADARSH CALIBRATION LLP" 
                className="h-20 transition-transform duration-300 group-hover:scale-105" 
              />
            </Link>

            {/* Desktop Nav */}
            <div className="hidden lg:flex items-center space-x-1">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-6 py-4 rounded-xl text-base font-semibold transition-all duration-300 ${
                    location.pathname === item.path
                      ? 'bg-gradient-to-r from-slate-700 to-slate-600 text-white shadow-lg'
                      : 'text-slate-300 hover:text-white hover:bg-slate-700'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden p-2 rounded-lg bg-slate-800 text-slate-300 hover:bg-slate-700 transition-colors"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <MdClose size={28} /> : <MdMenu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-slate-800 border-t border-slate-700 shadow-2xl">
            <div className="px-4 py-4 space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={closeMobileMenu}
                  className={`block px-4 py-3 rounded-lg text-base font-semibold ${
                    location.pathname === item.path
                      ? 'bg-slate-700 text-white'
                      : 'text-slate-300 hover:bg-slate-700'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>

      {/* Features Bar */}
      <FeaturesBar />
    </div>
  );
};

export default Navbar;


const FeaturesBar = () => {
  const features = [
    {
      icon: <BsAwardFill size={24} />,
      title: "ISO/IEC 17025 : 2017 Certified",
    },
    {
      icon: <MdBuild size={24} />,
      title: "On-Site Calibration",
    },
    {
      icon: <MdTimer size={24} />,
      title: "Rapid Turnaround",
    },
    {
      icon: <FaTags size={24} />,
      title: "All Major Brands",
    },
    {
      icon: <FaUser size={24} />,
      title: "Account Managed",
    },
    {
      icon: <FaBrain size={24} />,
      title: "15 Years Experience",
    },
  ];

  return (
    <div className="bg-gradient-to-r from-slate-800 to-slate-700 py-3 shadow-lg border-t border-slate-600">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-2">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-center space-x-2 text-slate-200 text-sm group cursor-default"
            >
              <div className="text-blue-400 group-hover:text-blue-300 transition-colors">{feature.icon}</div>
              <span className="font-medium group-hover:text-white transition-colors">{feature.title}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

